<!-- 
程式：ODAVF103.vue
功能：5.6月全站活動需求
作者：i9400597 叢伯蘭
完成：2020-04-22
-->
<template>
  <div class="content_font">
    <div class="l-container">
      <div class="o-menuMask"></div>
      <header
        class="l-header"
        style="width: 100%; position: fixed; z-index: 99; margin-top: -8px"
      >
        <div class="l-header__wrap">
          <div class="l-header__content">
            <div class="l-header__logo">
              <a href="javascript:;" id="CI_Link">
                <picture>
                  <source
                    srcset="@/assets/webpage/action1/images/logo/logo-m.svg"
                    media="(max-width: 1040px)"
                  />
                  <img
                    srcset="@/assets/webpage/action1/images/logo/logo.svg"
                    class="o-logo"
                    style="height:32px;width:auto;vertical-align:middle;"
                  />
                </picture>
              </a>
              <a
                :href="VUE_APP_LINK_WTHOME"
                target="_blank"
                title="回網路投保首頁"
                style="margin-left:32px;"
              >
                <span>網路投保</span>
              </a>
            </div>
          </div>
        </div>
      </header>
      <main class="l-main" style="margin-top: 60px">
        <!--section A-->
        <section class="l-mainKv">
          <div class="l-mainKv__slider slick-initialized slick-slider">
            <div class="slick-list draggable">
              <div
                class="o-banner"
                style="width: 100%; display: inline-block; margin-top: 5px"
              >
                <picture>
                  <source
                    srcset="@/assets/webpage/action3/images/kv/kv_800x900.jpg"
                    media="(max-width: 767px)"
                  />
                  <source
                    srcset="@/assets/webpage/action3/images/kv/kv_1200x1920.jpg"
                    media="(max-width: 1023px)"
                  />
                  <img
                    srcset="@/assets/webpage/action3/images/kv/kv_1600x600.jpg"
                    class="o-banner__photo"
                    alt
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>
        <!--section B-->
        <section class="l-indexAd">
          <div
            class="l-mainKv__slider slick-initialized slick-slider u-align-center"
          >
            <div class="slick-list draggable">
              <div
                style="
                  width: 100%;
                  display: inline-block;
                  margin-top: 5px;
                  max-width: 1200px;
                "
              >
                <picture>
                  <source
                    srcset="@/assets/webpage/action3/images/kv/kv2_480x590.jpg"
                    media="(max-width: 767px)"
                  />
                  <source
                    srcset="@/assets/webpage/action3/images/kv/kv2_1200x470.jpg"
                    media="(max-width: 1023px)"
                  />
                  <img
                    srcset="@/assets/webpage/action3/images/kv/kv2_1200x470.jpg"
                    class="o-banner__photo"
                    alt
                    style="z-index: 1"
                  />
                </picture>
                <picture>
                  <img
                    srcset="@/assets/webpage/action3/images/kv/CTA.png"
                    class="o-banner__photo CTAimg"
                    id="cta_sup"
                    @click="insertEventAction()"
                  />
                  <span
                    class="totalcount"
                    style="color: #43d091"
                    ref="totalcntstr"
                    >{{ totalcntstr }}</span
                  >
                </picture>
                <!-- 手機版-支持醫務按鈕 -->
                <div
                  class="CTAimg_m u-align-center CTA_div"
                  style="
                    z-index: 2;
                    background-color: red;
                    font-size: 28px;
                    padding: 0px 64px;
                    position: absolute;
                    border-radius: 23px;
                    font-weight: bolder;
                    width: 50%;
                  "
                >
                  <a
                    :href="`javascript:;`"
                    style="color: white"
                    id="cta_sup_m"
                    @click="insertEventAction()"
                    >支持醫務+1</a
                  >
                </div>
              </div>
              <!-- 手機版-支持醫務按鈕提示文字 -->
              <div class="ipDiv_m" style="height: 80px">
                <span
                  >※每IP位址僅能「支持醫務＋1」一次，重複點擊則不予計算。</span
                >
              </div>
              <span
                class="CTAimg_m u-floatL"
                style="
                  cursor: pointer;
                  z-index: 2;
                  font-size: 18px;
                  width: 50%;
                  text-align: left;
                  margin: -1px 0px 15px 7%;
                  font-weight: bold;
                "
                >分享給更多人支持</span
              >
              <img
                srcset="@/assets/webpage/action3/images/kv/plurk.png"
                class="plurkshare"
                @click="plurkshare()"
                id="ins_plurk"
              />
              <img
                srcset="@/assets/webpage/action3/images/kv/LINE.png"
                class="lineshare"
                @click="lineshare()"
                id="ins_line"
              />
              <img
                srcset="@/assets/webpage/action3/images/kv/FB.png"
                class="fbshare"
                @click="fbshare()"
                id="ins_fb"
              />
              <span
                class="ipDiv"
                style="
                  position: absolute;
                  top: 84%;
                  z-index: 2;
                  font-size: initial;
                  width: 230px;
                  height: 20px;
                "
                >※每IP位址僅能「支持醫務＋1」一次，重複點擊則不予計算。</span
              >
            </div>
          </div>
        </section>
        <!--section C-->
        <span class="anchor" id="sectionC"></span>
        <section class="l-mainProduct">
          <h1 class="l-mainProduct__title o-heading" style="margin: 0 10px 0">
            線上投保幫你捐1％，再送萬元家電
          </h1>
          <div class="l-wrap">
            <div class="c-pdContent">
              <div class="c-pdContent__head">
                <h2
                  class="l-mainProduct__title"
                  style="color: #333333; margin: 0px 10px"
                >
                  Dyson空氣清淨機、Dyson智能吸塵機器人、Dyson除塵螨機一抽入袋！
                </h2>
              </div>
              <div
                class="l-pageTab__content u-gutterNext--md"
                style="margin-top: 50px"
              >
                <ul class="o-list o-list--decimal" style="padding-right: 30px">
                  <p style="font-weight: bold">活動期間:</p>
                  <p>2020年5月1日起至2020年6月30日止。</p>
                  <br />
                  <p style="font-weight: bold">活動辦法:</p>
                  <li style="margin-left: 20px">
                    線上投保壽險、意外險、年金險，國泰人壽將捐出投保保費的1％給中華民國醫務社會工作協會。
                  </li>
                  <li style="margin-left: 20px">
                    線上投保以下商品，無須登錄，直接獲得抽獎機會：
                    <ul style="list-style-type: disc">
                      <li>
                        投保新e把罩定期壽險、iLove小額終老保險、新e路平安意外險、iCarry意外險，即獲2次抽獎機會。
                      </li>
                      <li>
                        投保iCarry意外險搭車族、騎士族、逍遊族方案，可獲得3次抽獎機會。
                      </li>
                      <li>
                        投保iMoney利變年金險：分期繳達3,000元即獲1次抽獎機會；躉繳每10萬元獲2次抽獎機會，每20萬獲4次抽獎機會，依此類推。
                      </li>
                      <li>
                        投保鑫Money利變年金險：躉繳每10萬元獲2次抽獎機會，每20萬獲4次抽獎機會，依此類推；指定企業客戶，躉繳每10萬元獲3次抽獎機會，20萬元獲6次抽獎機會，依此類推。
                      </li>
                    </ul>
                  </li>
                  <div class="l-pdTable">
                    <table
                      class="c-grid c-grid--view"
                      style="text-align: center"
                    >
                      <tr>
                        <td style="background: #dbf1dc; word-break: keep-all">
                          獎項
                        </td>
                        <td style="background: #dbf1dc; word-break: keep-all">
                          獎品內容
                        </td>
                      </tr>
                      <tr>
                        <td>頭獎</td>
                        <td>
                          Dyson 360 Heurist 智能吸塵機器人，1名，市價32,900元 。
                        </td>
                      </tr>
                      <tr>
                        <td>貳奬</td>
                        <td>
                          Dyson Pure Cool 智慧空氣清淨機
                          DP04，1名，市價19,900元。
                        </td>
                      </tr>
                      <tr>
                        <td>參獎</td>
                        <td>Dyson V6 Mattress除塵螨機，1名，市價15,900元。</td>
                      </tr>
                    </table>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <!--section D-->
        <section class="l-mainProduct" id="sectionD">
          <div class="l-wrap">
            <div class="l-mainProduct__container">
              <!--壽險-->
              <div class="l-cols__4 l-cols__4@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__imgContainer">
                    <a :href="`javascript:;`" id="insurance01PIC">
                      <picture>
                        <source
                          srcset="
                            @/assets/webpage/product/product02_1_580x490.jpg
                          "
                          media="(max-width: 767px)"
                        />
                        <source
                          srcset="
                            @/assets/webpage/product/product02_1_270x225.jpg
                          "
                          media="(max-width: 1023px)"
                        />
                        <img
                          srcset="
                            @/assets/webpage/product/product02_1_270x225.jpg
                          "
                          class="c-productCard__img picturefill-background"
                          style="z-index: 1; width: 100%; height: auto"
                        />
                      </picture>
                      <picture>
                        <img
                          srcset="@/assets/webpage/product/label.png"
                          class="c-productCard__img labelimg"
                        />
                      </picture>
                    </a>
                  </div>
                  <div class="prodCard" style="padding-bottom: 10px">
                    <div
                      style="
                        text-align: center;
                        font-weight: bold;
                        color: black;
                        padding: 8% 0;
                      "
                    >
                      壽險
                    </div>
                    <p>
                      凡投保新e把罩定期壽險、iLove小額終老保險，即獲 2
                      次抽獎機會。
                    </p>
                  </div>
                  <div class="u-align-center" style="display: flex">
                    <a
                      :href="VUE_APP_LINK_INSURED4"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_life_i"
                      style="width: 48%; margin: 1%"
                      @click="CFiLoveJump()"
                      >iLove</a
                    >
                    <a
                      :href="VUE_APP_LINK_INSURED7"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_life_e"
                      style="width: 48%; margin: 1%"
                      @click="CFeJump()"
                      >新e把罩</a
                    >
                  </div>
                </div>
              </div>
              <!--意外險-->
              <div class="l-cols__4 l-cols__4@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__imgContainer">
                    <a :href="`javascript:;`" id="insurance02PIC">
                      <picture>
                        <source
                          srcset="
                            @/assets/webpage/product/product04_1_580x490.jpg
                          "
                          media="(max-width: 767px)"
                        />
                        <source
                          srcset="
                            @/assets/webpage/product/product04_1_270x225.jpg
                          "
                          media="(max-width: 1023px)"
                        />
                        <img
                          srcset="
                            @/assets/webpage/product/product04_1_270x225.jpg
                          "
                          class="c-productCard__img picturefill-background"
                          style="z-index: 1; width: 100%; height: auto"
                        />
                      </picture>
                      <picture>
                        <img
                          srcset="@/assets/webpage/product/label.png"
                          class="c-productCard__img labelimg"
                        />
                      </picture>
                    </a>
                  </div>
                  <div class="prodCard" style="padding-bottom: 10px">
                    <div
                      style="
                        text-align: center;
                        font-weight: bold;
                        color: black;
                        padding: 8% 0;
                      "
                    >
                      意外險
                    </div>
                    <ul>
                      <li>
                        凡投保新e路平安意外險、iCarry意外險，即獲 2 次抽獎機會。
                      </li>
                      <li>
                        投保iCarry意外險搭車族、騎士族、逍遊族方案，可獲 3
                        次抽獎機會。
                      </li>
                    </ul>
                  </div>
                  <div class="u-align-center" style="display: flex">
                    <a
                      :href="VUE_APP_LINK_INSURED6"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_eacc"
                      style="width: 51%; margin: 1%"
                      @click="CFeaccidentJump()"
                      >新e路平安</a
                    >
                    <a
                      :href="VUE_APP_LINK_INSURED5"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_icarry"
                      style="width: 46%; margin: 1%"
                      @click="CFiCarryJump()"
                      >iCarry</a
                    >
                  </div>
                </div>
              </div>
              <!--年金險-->
              <div class="l-cols__4 l-cols__4@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__imgContainer">
                    <a :href="`javascript:;`" id="insurance03PIC">
                      <picture>
                        <source
                          srcset="
                            @/assets/webpage/product/product06_1_580x490.jpg
                          "
                          media="(max-width: 767px)"
                        />
                        <source
                          srcset="
                            @/assets/webpage/product/product06_1_270x225.jpg
                          "
                          media="(max-width: 1023px)"
                        />
                        <img
                          srcset="
                            @/assets/webpage/product/product06_1_270x225.jpg
                          "
                          class="c-productCard__img picturefill-background"
                          style="z-index: 1; width: 100%; height: auto"
                        />
                      </picture>
                      <picture>
                        <img
                          srcset="@/assets/webpage/product/label.png"
                          class="c-productCard__img labelimg"
                        />
                      </picture>
                    </a>
                  </div>
                  <div class="prodCard" style="padding-bottom: 10px">
                    <div
                      style="
                        text-align: center;
                        font-weight: bold;
                        color: black;
                        padding: 8% 0;
                      "
                    >
                      年金險
                    </div>
                    <ul>
                      <li>小資分期繳達 3,000 元，即獲 1 次抽獎機會。</li>
                      <li>
                        大戶躉繳每 10 萬元可獲 2 次抽獎機會， 20 萬元獲 4
                        次抽獎機會，依此類推。
                        <br />※鑫Money指定企業客戶再多送 1 抽！
                      </li>
                    </ul>
                  </div>
                  <div class="u-align-center" style="display: flex">
                    <a
                      :href="VUE_APP_LINK_INSURED2"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_imoney"
                      style="width: 48%; margin: 1%"
                      @click="CFiMoneyJump()"
                      >iMoney</a
                    >
                    <a
                      :href="VUE_APP_LINK_INSURED3"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_smoney"
                      style="width: 48%; margin: 1%"
                      @click="CFgoldMoneyJump()"
                      >鑫Money</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!--section E-->
        <span class="anchor" id="sectionE"></span>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;領獎及抽獎方式&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <p>
                本公司將於活動期間屆滿後一個月內，以電腦隨機抽獎。並於抽獎日後一個月內，於本活動網站公告得獎名單，且以Email方式各別通知得獎者。得獎者須於抽獎日後15日內完成領獎，逾期未領獎者，視為放棄得獎資格。
              </p>
              <p>
                ※網路投保儲蓄型保險、保障型保險需完成繳費且無撤銷或解約之情事，才可具有抽獎資格。
              </p>
            </div>
          </div>
        </section>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;捐贈作業與公告&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <p>
                本公司將於活動期間屆滿後一個月內，於本活動網站公告受捐單位與款項。
              </p>
            </div>
          </div>
        </section>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;捐贈明細&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <div class="l-pdTable">
                <table class="c-grid c-grid--view">
                  <tr class="is-central">
                    <td style="background: #dbf1dc">捐款日期</td>
                    <td style="background: #dbf1dc">受捐單位</td>
                    <td style="background: #dbf1dc">捐款金額（元）</td>
                    <td style="background: #dbf1dc">捐款單位</td>
                  </tr>
                  <tr class="is-central">
                    <td>7/17</td>
                    <td>中華民國醫務社會工作協會</td>
                    <td>79,167</td>
                    <td>國泰人壽保險股份有限公司</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;得獎名單&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <div class="l-pdTable">
                <table class="c-grid c-grid--view">
                  <tr class="is-central">
                    <td style="background: #dbf1dc">獎項</td>
                    <td style="background: #dbf1dc">得獎人姓名</td>
                    <td style="background: #dbf1dc">email</td>
                  </tr>
                  <tr class="is-central">
                    <td>Dyson 360 Heurist 智能吸塵機器人</td>
                    <td>楊○雲</td>
                    <td>ky*****umi@gmail.com</td>
                  </tr>
                  <tr class="is-central">
                    <td>Dyson Pure Cool 智慧空氣清淨機 DP04</td>
                    <td>林○蓁</td>
                    <td>mi*****06@gmail.com</td>
                  </tr>
                  <tr class="is-central">
                    <td>Dyson V6 Mattress 除塵螨機</td>
                    <td>顏○如</td>
                    <td>ju*****sper6@gmail.com</td>
                  </tr>
                </table>
                <p>
                  ※請得獎者於註冊Email收取領獎通知，並於2020/8/14前寄回回函。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;注意事項&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <ul class="o-list o-list--decimal">
                <li>本活動限自然人參加。</li>
                <li>本公司指定企業如下:</li>
                <table>
                  <tr>
                    <td data-title="合作夥伴">
                      <div class="l-pdTable">
                        <table class="c-grid c-grid--view">
                          <tr>
                            <td
                              style="background: #dbf1dc; word-break: keep-all"
                              rowspan="15"
                            >
                              企業名稱
                            </td>
                            <td>全漢企業股份有限公司</td>
                          </tr>
                          <tr>
                            <td>全漢企業股份有限公司高雄分公司</td>
                          </tr>
                          <tr>
                            <td>向漢科技有限公司</td>
                          </tr>
                          <tr>
                            <td>富創源股份有限公司</td>
                          </tr>
                          <tr>
                            <td>善元科技股份有限公司</td>
                          </tr>
                          <tr>
                            <td>天主教若瑟醫療財團法人</td>
                          </tr>
                          <tr>
                            <td>財團法人天主教若瑟社會福利基金會</td>
                          </tr>
                          <tr>
                            <td>兆聯實業股份有限公司</td>
                          </tr>
                          <tr>
                            <td>信和材料科技股份有限公司</td>
                          </tr>
                          <tr>
                            <td>兆聯技術服務有限公司</td>
                          </tr>
                          <tr>
                            <td>亦則檢測科技有限公司</td>
                          </tr>
                          <tr>
                            <td>中鋼保全股份有限公司</td>
                          </tr>
                          <tr>
                            <td>鋼堡科技股份有限公司</td>
                          </tr>
                          <tr>
                            <td>中鋼公寓大廈管理維護股份有限公司</td>
                          </tr>
                          <tr>
                            <td>昇恒昌股份有限公司</td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </table>

                <p>
                  上述指定企業員工需於2020/05/01~2020/06/30投保時，於合作夥伴活動登錄點選「團險企業客戶專案」，如未於投保時點選，視同放棄增加抽獎機會，且投保完成後亦不得補登錄。投保之保險商品須經本公司同意承保且無契約撤回情事。
                </p>

                <li>
                  參加者於參加本活動時，即表示同意本活動辦法，並充分知悉與同意以下事項:
                  <p>
                    本公司得因本活動之需要，依個人資料保護相關規定，於參加者同意之期間內，以電子檔或紙本形式於我國境內蒐集、處理、利用其個人資料。但本公司於未經參加者之同意下，不得利用參加者之個人資料進行商業行銷行為。參加者可自由選擇是否提供完整個人資訊，惟若資訊不完整者，將無法參加本活動。
                  </p>
                  <p>
                    參加者可電洽本公司免費客服專線(0800-036-599)，針對其個人資料行使請求答覆查詢、提供閱覽、製給複製本、更正、補充、停止蒐集、處理、利用或刪除之權利，亦可至本公司官方網站法令公告之「個人資料保護法」應告知事項專區
                    (網址：https://www.cathaylife.com.tw/cathaylife/about/info/info-security/info-security)進一步了解詳細資訊。
                  </p>
                </li>
                <li>
                  本活動如有任何因電腦、網路、電話、技術或其他不可歸責於本公司之事由，致參加者所寄出、填寫或登錄之資料有遺失、錯誤、無法辨識或毀損等情形，本公司不負任何法律責任。
                </li>
                <li>
                  本公司有權檢視得獎情況是否有人為操作之行為，對於以偽造、詐欺或其他不正當之方式意圖兌領之參加者，本公司有權撤銷其得獎資格或拒絕其參與本活動。
                </li>
                <li>
                  得獎者身分之認定係依本公司資料庫電子郵件所對應（或參加者所填寫、登錄）之身分證字號為主，得獎者須提供正確之身分證影本，並經本公司確認無誤後始得領獎。
                </li>
                <li>
                  本活動獎品寄送地址僅限中華民國境內，如得獎者未能於領獎期限前回覆有效國內寄送地址，本公司得取消其得獎資格。
                </li>
                <li>
                  得獎者逾期未領獎或因留存資料不完整或錯誤致無法通知得獎者，視同放棄得獎資格，不接受開立扣繳憑單者，亦同。
                </li>
                <li>本活動獎品不得要求轉換、轉讓或折換現金。</li>
                <li>
                  本活動獎品悉以實物為準，網頁上照片、圖案等僅供參考，恕不挑色；如遇缺貨或不可抗力之因素無法提供時，本公司有權以其他等值商品替代。
                </li>
                <li>
                  依稅法規定，得獎者若為中華民國境內居住之個人，且年度所得獎項價值累積超過1,000元時，本公司將於翌年開立所得稅扣繳憑單予得獎者，如所得獎項價值達20,010元(含)時，得獎者須先繳交10%機會中獎稅金，始可領獎。得獎者若為非中華民國境內居住之個人(即在中華民國境內居住未達183天之本國人及外國人)，不論得獎獎項價值，均須先就得獎所得扣繳20%機會中獎稅金，始可領獎，本公司並將依法開立所得稅扣繳憑單。若未能依法繳納應繳稅額，即視為喪失得獎資格。參加者因參加本活動而須支付之任何稅捐皆為參加者之義務，概與本公司無關。前述稅捐法規如有更新或變動者，依修正後之規定辦理。
                </li>
                <li>
                  本公司非獎品製造者或提供者，與各項獎品或服務之製造或提供廠商無任何代理或合夥關係，且本活動獎品之保固期限均依廠商出廠時實際提供者為準。得獎者如因本活動各項獎品、服務或保固發生任何爭議，概與本公司無關。
                </li>
                <li>
                  本公司保有取消、終止、修改或暫停本活動相關內容之權利，並得以公告方式通知參加者。如有未盡事宜，悉依本公司相關規定或解釋辦理。
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <footer class="l-footer">
        <div class="l-footer__contactUs">
          <div class="l-footer__wrap">
            <ul class="c-footLinks">
              <li>
                <a
                  :href="VUE_APP_LINK_MEMBER"
                  target="_blank"
                  class="c-footLinks__link"
                  >會員專區</a
                >
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_CONNECTION"
                  target="_blank"
                  class="c-footLinks__link"
                  >聯絡我們</a
                >
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_SECRET"
                  target="_blank"
                  class="c-footLinks__link"
                  >顧客資料保密措施</a
                >
              </li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="l-footer__copyright">
          <div class="l-footer__wrap">© 國泰人壽保險股份有限公司</div>
        </div>
      </footer>
      <a href="javascript:;" class="o-gotoTop" data-id="gotop"></a>
    </div>
    <div id="CI_LINK_MSG" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title">提醒您</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">您將離開本頁面，並前往國泰人壽官網首頁。</div>
        <div class="c-popup__actions">
          <a
            href="javascript:;"
            class="o-btn o-btn--normal"
            style="margin-right: 5px"
            data-mfp-close
            >取消</a
          >
          <a
            @click="gotoCathayLife"
            class="o-btn o-btn--normal o-btn--primary"
            style="margin-left: 5px"
            >立即前往</a
          >
        </div>
      </div>
    </div>
    <div id="InsertSuccess" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title" style="height: 45px"></div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content" style="padding-bottom: 20px">
          <h2 style="margin: 0px; padding-bottom: 30px">感謝您的支持!</h2>
          國泰人壽會幫您把愛心送給醫療協會喔!
        </div>
      </div>
    </div>
    <div id="InsertFail" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title" style="height: 45px"></div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content" style="padding-bottom: 20px">
          <h2 style="margin: 0px; padding-bottom: 30px">您已經支持過嚕!</h2>
          國泰人壽會幫您把愛心送給醫療協會喔!
        </div>
      </div>
    </div>
    <div id="activeFinish" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title" style="height: 45px"></div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">
          <h2 style="margin: 0px; padding: 15px 0px">
            本活動時間已經結束，
            <br />期待下次再見。
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DTODAV03 from "@/service/DTODAV03.js";
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

export default {
  name: "ODAVF103",
  data() {
    return {
      totalcntstr: "000000",
      promptNum: 0,
      time: null,
      //國泰人壽首頁
      VUE_APP_LINK_CATHAYLIFE: process.env.VUE_APP_LINK_CATHAYLIFE,
      //網路投保首頁
      VUE_APP_LINK_WTHOME: process.env.VUE_APP_LINK_WTHOME,
      //會員專區
      VUE_APP_LINK_MEMBER: process.env.VUE_APP_LINK_MEMBER,
      //聯絡我們
      VUE_APP_LINK_CONNECTION: process.env.VUE_APP_LINK_CONNECTION,
      //顧客資料保密措施
      VUE_APP_LINK_SECRET: process.env.VUE_APP_LINK_SECRET,
      //(iMoney)
      VUE_APP_LINK_INSURED2:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC0_1000/prompt?page=calculator",
      //(鑫Money)
      VUE_APP_LINK_INSURED3:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC1_1000/prompt?page=calculator",
      //(iLove)
      VUE_APP_LINK_INSURED4:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE2_1000/prompt?page=calculator",
      //(iCarry)
      VUE_APP_LINK_INSURED5:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID0_1000/prompt?page=calculator",
      //(新e路平安)
      VUE_APP_LINK_INSURED6:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID1_1000/prompt?page=calculator",
      //(新e把罩壽險)
      VUE_APP_LINK_INSURED7:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE3_1000/prompt?page=calculator",
    };
  },
  metaInfo() {
    return {
      title: "國泰「醫」起送　愛心無上限｜國泰人壽",
      meta: [
        {
          name: "keyWords",
          content:
            "國泰人壽, 網路投保, 年金險, 壽險, 旅平險,保險, 保障, 醫療保險, 醫療險, 傷害險, e悠遊, 鑫Money, iMoney, iCarry, iLove,新e把罩, 新 e 路平安, 意外險,中華民國醫務社會工作協會, 捐贈, 捐款, 公益,Insurance",
        },
        {
          name: "description",
          content:
            "活動期間內，你動手指我來捐款支持醫務協會。線上投保壽險、意外險、年金險，國泰就幫你捐出1％印象款項，再送你抽Dyson萬元家電！",
        },
        {
          name: "image",
          content:
            "https://patron.cathaylife.com.tw/ODAV/assets/kv/kv_1600x600.jpg",
        },

        {
          property: "og:title",
          content: "國泰「醫」起送　愛心無上限｜國泰人壽",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:description",
          content:
            "活動期間內，你動手指我來捐款支持醫務協會。線上投保壽險、意外險、年金險，國泰就幫你捐出1％款項，再送你抽Dyson萬元家電！",
        },
        {
          property: "og:url",
          content: "https://patron.cathaylife.com.tw/ODAV/action/event20200506",
        },
        {
          property: "og:image",
          content:
            "https://patron.cathaylife.com.tw/ODAV/assets/kv/kv_1600x600.jpg",
        },

        {
          property: "og:image:width",
          content: "1200",
        },
        {
          property: "og:image:height",
          content: "630",
        },
      ],
    };
  },
  methods: {
    //(iMoney)
    CFiMoneyJump() {
      var a = location.href;
      var b =
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC0_0500/prompt";
      var c = a.split("?")[1];
      window.location.href = b + "?" + c;
    },
    //(鑫Money)
    CFgoldMoneyJump() {
      var a = location.href;
      var b =
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC1_0500/prompt";
      var c = a.split("?")[1];
      window.location.href = b + "?" + c;
    },
    //(iLove)
    CFiLoveJump() {
      var a = location.href;
      var b =
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE2_0500/prompt";
      var c = a.split("?")[1];
      window.location.href = b + "?" + c;
    },
    //(iCarry)
    CFiCarryJump() {
      var a = location.href;
      var b =
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID0_0500/prompt";
      var c = a.split("?")[1];
      window.location.href = b + "?" + c;
    },
    //(新e路平安)
    CFeaccidentJump() {
      var a = location.href;
      var b =
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID1_0500/prompt";
      var c = a.split("?")[1];
      window.location.href = b + "?" + c;
    },
    //(新e把罩壽險)
    CFeJump() {
      var a = location.href;
      var b =
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE3_0500/prompt";
      var c = a.split("?")[1];
      window.location.href = b + "?" + c;
    },
    // 前往國泰人壽
    gotoCathayLife() {
      window.location.href = this.VUE_APP_LINK_CATHAYLIFE;
    },
    scrollAnchor(id) {
      let animationTime = {
        type: Number,
        default: 300,
      };
      let move = $("#" + id).offset().top - 65;
      $("html").animate({ scrollTop: move }, this.animationTime);
    },
    getTotalCnt() {
      this.req = {
        act_id: "event20200506",
        event_id: "cta_sup",
      };
      var num = 0;
      let cthis = this;
      this.$cathayAxios.post(DTODAV03.getTotalCnt, this.req).then((resp) => {
        if (resp.returnCode === 0) {
          num = resp.data;
          $({ Counter: 0 }).animate(
            { Counter: num },
            {
              duration: 400,
              easing: "swing",
              step: function (now) {
                cthis.totalcntstr = Math.ceil(now).toString().padStart(6, "0");
              },
            }
          );
        }
      });
    },
    insertEventAction() {
      gtag("event", "click_支持醫務", {
        event_category: "click_cta_sup",
        event_label: "國泰醫起送_愛心無上限",
        value: 1,
      });

      let momentupdate = require("moment");
      //若已超過活動期間，則跳出訊息結束function
      if (!momentupdate().isBefore("2020-07-01")) {
        $.magnificPopup.open({
          items: { src: "#activeFinish", type: "inline" },
          touch: false,
        });
        return;
      }

      let updatenow = new Date().getTime();
      let updatetime = momentupdate(updatenow).format(
        "YYYY-MM-DD HH:mm:ss.SSS"
      );
      this.time = updatetime;
      this.req = {
        act_id: "event20200506",
        event_id: "cta_sup",
        event_type: "click",
        tm: this.time,
      };
      this.$cathayAxios
        .post(DTODAV03.insertEventAction, this.req)
        .then((resp) => {
          if (resp.returnCode === 0) {
            $.magnificPopup.open({
              items: { src: "#InsertSuccess", type: "inline" },
              touch: false,
            });
            this.getTotalCnt();
          } else {
            $.magnificPopup.open({
              items: { src: "#InsertFail", type: "inline" },
              touch: false,
            });
          }
        });
    },
    initFun() {
      $("#CI_Link").on("click", function (e) {
        e.preventDefault();
        $.magnificPopup.open({
          items: {
            src: "#CI_LINK_MSG",
            type: "inline",
          },
          callbacks: {
            open: function () {
              $("#CI_LINK_MSG_Link1").on("click", function (e) {
                e.preventDefault();
                window.location = VUE_APP_LINK_CATHAYLIFE;
              });

              $("#CI_LINK_MSG .o-btn--normal[data-mfp-close]").on(
                "click",
                function (e) {
                  e.preventDefault();
                  $.magnificPopup.close();
                }
              );
            },
          },
        });
      });
    },
    plurkshare() {
      window.open(
        "http://www.plurk.com/?qualifier=shares&status=".concat(
          encodeURIComponent(
            "https://patron.cathaylife.com.tw/ODAV/action/event20200506"
          )
        )
      );
    },
    lineshare() {
      window.open(
        "http://line.naver.jp/R/msg/text/?" +
          encodeURIComponent(
            "https://patron.cathaylife.com.tw/ODAV/action/event20200506"
          ),
        "_blank"
      );
    },
    fbshare() {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" +
          "https://patron.cathaylife.com.tw/ODAV/action/event20200506",
        "Share"
      );
    },
    //畫面於指定區塊時，才開始執行支援人數計算&轉動
    getScrollNum() {
      let cthis = this;
      let distanceOfTop = $(window).scrollTop(); //畫面當前與最上方的高度
      let bannerHeight = $(".l-mainKv").height(); //banner區塊高度

      //若為初始進入(promptNum=0) 且 畫面當前高度>banner三分之二高度 且 畫面當前高度<(banner區塊高度+支持醫務區塊高度)
      if (
        this.promptNum == 0 &&
        distanceOfTop > (bannerHeight / 3) * 2 &&
        distanceOfTop < bannerHeight + $(".l-indexAd").height()
      ) {
        cthis.getTotalCnt();
        this.promptNum++;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initFun();
    });
    window.addEventListener("scroll", this.getScrollNum);
  },
  created() {
    import("@/assets/webpage/js/vendor/modernizr-3_5_0-min.js").then((m) => {});

    import("@/assets/webpage/js/vendor/picturefill/picturefill-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/picturefill/pf-mutation-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/matchMedia/matchMedia-min.js").then(
      (m) => {}
    );
  },
};
</script>
<style
  src="@/assets/webpage/css/jquery_fancyform/jquery_fancyform_min.css"
></style>
<style scoped src="@/assets/webpage/js/vendor/slick/slick-min.css"></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/slick/slick-theme-min.css"
></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/bootstrap-datepicker/bootstrap-datepicker.standalone.min.css"
></style>
<style scoped src="@/assets/webpage/css/common/normalize-min.css"></style>
<style scoped src="@/assets/webpage/css/common/animate-min.css"></style>
<style scoped src="@/assets/webpage/css/common/layout-min.css"></style>
<style scoped src="@/assets/webpage/css/form-min.css"></style>
<style scoped src="@/assets/webpage/css/product-min.css"></style>
<style scoped src="@/assets/webpage/css/index.css"></style>
<style scoped src="@/assets/webpage/css/common/main.css"></style>
<style scoped src="@/assets/third-party/css/font-awesome.min.css"></style>
<style scoped>
.c-popup__content {
  background-color: white;
}
.content_font {
  font-size: 16px;
  line-height: 1.5;
  color: #666;
  font-family: Arial, "Microsoft JhengHei", Helvetica, sans-serif;
}

@media (min-width: 1575px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 30%;
    left: 70%;
    width: 244px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 71%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 67%;
    z-index: 2;
    font-size: 53px;
  }
  .plurkshare {
    position: absolute;
    left: 52%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 55%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 58%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
}
@media (max-width: 1574px) and (min-width: 1201px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 30%;
    left: 72%;
    width: 244px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 73%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 68%;
    z-index: 2;
    font-size: 46px;
  }
  .plurkshare {
    position: absolute;
    left: 52%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 56%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 60%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
}
@media (max-width: 1200px) and (min-width: 1024px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 30%;
    left: 74%;
    width: 222px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 74%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 69%;
    z-index: 2;
    font-size: 38px;
  }
  .plurkshare {
    position: absolute;
    left: 53%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 57%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 61%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
}
@media (max-width: 1023px) and (min-width: 768px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 29%;
    left: 75%;
    width: 175px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 72%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 69%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 53%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 57%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 61%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
}
@media (max-width: 767px) {
  .l-mainProduct__container {
    max-height: 1800px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 96px;
    height: 96px;
    left: 15px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 66%;
    left: 24%;
    width: 56%;
    cursor: pointer;
    display: none;
  }
  .CTAimg_m {
    display: block;
    top: 68%;
  }
  .ipDiv {
    display: none;
  }
  .ipDiv_m {
    display: block;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 52%;
    top: 58%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 52%;
    top: 91%;
    z-index: 3;
    width: 40px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 66%;
    top: 91%;
    z-index: 3;
    width: 40px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 80%;
    top: 91%;
    z-index: 3;
    width: 40px;
    cursor: pointer;
  }
}
@media (max-width: 412px) {
  .totalcount {
    position: absolute;
    left: 52%;
    top: 57%;
    z-index: 2;
    font-size: 30px;
  }
}
@media (max-width: 361px) {
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 52%;
    top: 56%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 56%;
    top: 90%;
    z-index: 3;
    width: 36px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 69%;
    top: 90%;
    z-index: 3;
    width: 36px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 82%;
    top: 90%;
    z-index: 3;
    width: 36px;
    cursor: pointer;
  }
}
@media (max-width: 320px) {
  .CTA_div {
    margin: -2px 0px 0px 5%;
  }
  .CTAimg_m {
    display: block;
    top: 64%;
  }
  .ipDiv {
    display: none;
  }
  .ipDiv_m {
    display: block;
  }
  .totalcount {
    position: absolute;
    left: 52%;
    top: 53%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 58%;
    top: 90%;
    z-index: 3;
    width: 33px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 71%;
    top: 90%;
    z-index: 3;
    width: 33px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 84%;
    top: 90%;
    z-index: 3;
    width: 33px;
    cursor: pointer;
  }
}
</style>
